import React from "react";
import { Button, Modal, Form } from "semantic-ui-react";
import { configOptions } from "env.config";

const HostFormModal = ({
  editStatus,
  openFormModal,
  formData,
  onChangeFormItem,
  onCloseFormModal,
  onSaveHost,
}) => {
  const getHostStatus = () => {
    const hostValid = formData.hostValid;
    if (hostValid === true) {
      return false;
    }
    if (hostValid === false) {
      return true;
    }
    return hostValid;
  };
  return (
    <Modal
      closeIcon
      size="small"
      open={openFormModal}
      onClose={onCloseFormModal}
    >
      <Modal.Header>{editStatus ? "Edit Host" : "Add Host"}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>Scope</label>
            <Form.Select
              fluid
              disabled={editStatus}
              options={configOptions.scope}
              value={formData.scope}
              placeholder="Scope"
              error={!formData.scopeValid}
              onChange={(_e, { value }) => onChangeFormItem("scope", value)}
            />
          </Form.Field>
          <Form.Field required>
            <label>Stage</label>
            <Form.Select
              fluid
              disabled={editStatus}
              options={configOptions.stage}
              value={formData.stage}
              placeholder="Stage"
              error={!formData.stageValid}
              onChange={(_e, { value }) => onChangeFormItem("stage", value)}
            />
          </Form.Field>
          <Form.Field required>
            <label>Host</label>
            <Form.Input
              disabled={editStatus}
              placeholder="Host"
              value={formData.host}
              error={getHostStatus()}
              onChange={(_e, { value }) => onChangeFormItem("host", value)}
            />
          </Form.Field>
          <Form.Field required>
            <label>Alias</label>
            <Form.Input
              placeholder="Alias"
              value={formData.name}
              error={!formData.nameValid}
              onChange={(_e, { value }) => onChangeFormItem("name", value)}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCloseFormModal}>Cancel</Button>
        <Button type="submit" positive onClick={onSaveHost}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export { HostFormModal };
